import { useEffect, useState } from 'react';
import { useTypedSelector } from '../../hooks/useTypedSelector';

interface UseChatProps {
  right?: boolean;
  hide?: boolean;
  header?: boolean;
}
const useChat = (props?: UseChatProps) => {
  const { right = false, hide = true, header = false } = props || {};
  const { user, logIn } = useTypedSelector((state) => state.layoutState);
  const [userInfo, setUserInfo] = useState<any>(() => ({
    id: sessionStorage.getItem('user_id'),
    name: sessionStorage.getItem('user_name'),
  }));

  const SITE_ID = process.env.REACT_APP_FRESHCHAT_SITE_ID;
  const FRESHCHAT_HOST = process.env.REACT_APP_FRESHCHAT_HOST;
  const SCRIPT_URL = process.env.REACT_APP_FRESHCHAT_SCRIPT_URL;
  const TOKEN = process.env.REACT_APP_FRESHCHAT_TOKEN;
  const WIDGETUUID = process.env.REACT_APP_WIDGETUUID;
  const COLOR = '#793EAD';

  useEffect(() => {
    const newUserInfo = {
      ...user,
      id: user?.id || sessionStorage.getItem('user_id'),
      name: user?.name || sessionStorage.getItem('user_name'),
    };
    setUserInfo(newUserInfo);
  }, [user, logIn]);

  useEffect(() => {
    function initFreshChat() {
      window.fcWidget.init({
        token: TOKEN,
        host: FRESHCHAT_HOST,
        widgetUuid: WIDGETUUID,
        siteId: SITE_ID,
        config: {
          cssNames: {
            widget: !right
              ? header
                ? 'custom_fc_frame_header'
                : 'custom_fc_frame'
              : '',
            open: 'custom_fc_open',
            expanded: 'custom_fc_expanded',
          },
          headerProperty: {
            backgroundColor: COLOR,
            hideChatButton: hide,
          },
        },
      });

      window.fcWidget.setExternalId(userInfo?.id || null);
      window.fcWidget.user.setProperties({
        firstName: userInfo?.name || null,
        email: userInfo?.email || null,
        userId: userInfo?.id || null,
      });
    }
    function initialize(i: Document, t: string) {
      let e;
      i.getElementById(t)
        ? initFreshChat()
        : (((e = i.createElement('script')).id = t),
          (e.async = !0),
          (e.src = SCRIPT_URL as string),
          (e.onload = initFreshChat),
          i.head.appendChild(e));
    }

    function initiateCall() {
      initialize(document, 'Freshchat-js-sdk');
    }

    window.addEventListener<'load'>('load', initiateCall, {
      once: true,
      passive: true,
    });

    return () =>
      window.removeEventListener<'load'>('load', initiateCall, false);
  }, [user, logIn]);
};

export default useChat;
